module.exports = __webpack_public_path__ + "static/media/info-fill.16bbf5e9.svg";